import { render } from "./pickUpEdit.vue?vue&type=template&id=be32528c&scoped=true"
import script from "./pickUpEdit.vue?vue&type=script&lang=js"
export * from "./pickUpEdit.vue?vue&type=script&lang=js"

import "./pickUpEdit.vue?vue&type=style&index=0&id=be32528c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be32528c"]])

export default __exports__